const getters = {
  wsToken: (state) => state.ws.wsToken,
  ws: (state) => state.ws.ws,
  isSocket: (state) => state.ws.isSocket,
  msg: (state) => state.ws.msg
}
export default getters
